import styles from './CmsImage.module.scss';
import Lightbox from './components/Lightbox/Lightbox';
import React, { useRef, useState } from 'react';
import {
  Figure,
  Image,
  Link,
  stripNonHtmlProps,
} from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';
import { useZoomAnimation } from '@components/hooks';

export const imageHeightMap = {
  small: 239,
  medium: 370,
  large: 536,
  default: 278,
};

const getImageHeight = (variant, fullHeight) =>
  variant === 'full'
    ? fullHeight
    : imageHeightMap[variant] || imageHeightMap.default;

const CmsImage = ({
  height,
  href,
  linkType,
  target,
  variant,
  width,
  ...props
}) => {
  switch (linkType) {
    case 'default':
      return (
        <Link target={target} to={href}>
          <Image
            className={classNames(styles.image, {
              [styles.isFull]: variant === 'full',
            })}
            height={getImageHeight(variant, height)}
            style={
              variant === 'full' ? { aspectRatio: `${width} / ${height}` } : {}
            }
            {...stripNonHtmlProps(props)}
          />
        </Link>
      );
    case 'lightbox': {
      const [open, setOpen] = useState(false);
      const dialog = useDialogStore({ open, setOpen });
      const imageRef = useRef();
      const imageStyles = useZoomAnimation(0.5, imageRef, open, 30, 1.4);

      return (
        <>
          <Lightbox
            imageStyles={imageStyles}
            open={open}
            store={dialog}
            {...stripNonHtmlProps(props)}
          />
          <figure className={styles.figure}>
            <DialogDisclosure
              aria-label="Bild vergrößern"
              className={styles.magnifyingButton}
              store={dialog}
            />
            <Image
              className={classNames(styles.image, {
                [styles.isFull]: variant === 'full',
              })}
              height={getImageHeight(variant, height)}
              ref={imageRef}
              style={
                variant === 'full'
                  ? { aspectRatio: `${width} / ${height}` }
                  : {}
              }
              {...stripNonHtmlProps(props)}
            />
          </figure>
        </>
      );
    }
    default:
      return (
        <Figure
          height={height}
          variant={variant}
          width={width}
          {...stripNonHtmlProps(props)}
        />
      );
  }
};

CmsImage.propTypes = {
  height: PropTypes.number.isRequired,
  href: PropTypes.string,
  linkType: PropTypes.oneOf(['default', 'lightbox']),
  target: PropTypes.string,
  variant: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  width: PropTypes.number.isRequired,
};

export default CmsImage;
